import {Component} from '@angular/core';
import {IonicPage, LoadingController, NavController, NavParams, Platform, ToastController} from 'ionic-angular';

// import { NewRegistrationExistsPage } from '../new-registration-exists/new-registration-exists';
import {NewSubscriptionStep3Page} from '../new-subscription-step3/new-subscription-step3';

// import { ValidatorProvider } from '../../providers/validator/validator';
import {AlertProvider} from '../../providers/alert/alert';
// import { AuthProvider } from '../../providers/auth/auth';
import {NewSubscriptionProvider} from '../../providers/new-subscription/new-subscription';
import {SubscriptionServerProvider} from '../../providers/subscription-server/subscription-server';

import {NewSubscription} from '../../models/newsubscription';

import * as _ from 'lodash';

/**
 * Generated class for the NewSubscriptionStep1Page page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */
@IonicPage()
@Component({
  selector: 'page-new-subscription-step2',
  templateUrl: 'new-subscription-step2.html',
})
export class NewSubscriptionStep2Page {

  public newSubscription: NewSubscription;
  public prices: any[] = [];
  public accessKind: any[] = [];

  public proofTypeId: number = 0;
  public proofType: string = null;

  public edited = true;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private platform: Platform,
    private alertProvider: AlertProvider,
    // private networkMonitor: NetworkMonitorProvider,
    // private authProvider: AuthProvider,
    private loadingCtrl: LoadingController,
    private toastCtrl: ToastController,
    // private authProvider: AuthProvider,
    // private validatorProvider: ValidatorProvider,
    private newSubscriptionProvider: NewSubscriptionProvider,
    private subscriptionServerProvider: SubscriptionServerProvider,
  ) {

    this.proofTypeId = navParams.get('proofTypeId');
    this.proofType = navParams.get('proofType');

    if (this.proofTypeId == 1 || this.proofTypeId == 2) {
      this.edited = false;
    }

    this.newSubscription = new NewSubscription();
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad NewSubscriptionStep2Page');
  }

  ionViewWillEnter() {
    let that = this;

    this.newSubscriptionProvider.load().subscribe((data: any) => {
      if (data) {

        that.newSubscription = data;

        let loader = that.loadingCtrl.create({
          content: 'Obtendo os detalhes...',
        });
        loader.present();

        that.prices = [];

        this.subscriptionServerProvider.fetchProofDetails(that.newSubscription.proofId, that.newSubscription.kind).subscribe((prices: any) => {
          // that.loading = false;

          try {
            _(prices).forEach((price: any) => {
              // if (proof.createdAt) {
              //   proof.createdAt = new Date(proof.createdAt.replace(/\s+/g, 'T').concat('.000-03:00'));
              // }

              // if (proof.finishedAt) {
              //   proof.finishedAt = new Date(proof.finishedAt.replace(/\s+/g, 'T').concat('.000-03:00'));
              // }

              if ((price.accessKind === 'APP') && (price.camera)) {
                price.code = 1;
                price.name = 'Aplicativo';
              } else if ((price.accessKind === 'WEB') && (price.camera)) {
                price.code = 2;
                price.name = 'Web com Câmera';
              } else if ((price.accessKind === 'WEB') && (!price.camera)) {
                price.code = 3;
                price.name = 'Web sem Câmera';
              }

              that.prices.push(price);
            });
            // if (prices.length > 0) {

            //   // for (let pi = 0; pi < prices.length; pi++) {
            //   //   let price = prices[pi];

            //   //   // if (proof.createdAt) {
            //   //   //   proof.createdAt = new Date(proof.createdAt.replace(/\s+/g, 'T').concat('.000-03:00'));
            //   //   // }

            //   //   // if (proof.finishedAt) {
            //   //   //   proof.finishedAt = new Date(proof.finishedAt.replace(/\s+/g, 'T').concat('.000-03:00'));
            //   //   // }

            //   //   if ((price.accessKind === 'APP') && (price.camera)) {
            //   //     price.name = 'Aplicativo';
            //   //   } else if ((price.accessKind === 'WEB') && (price.camera)) {
            //   //     price.name = 'Web com Câmera';
            //   //   } else if ((price.accessKind === 'WEB') && (!price.camera)) {
            //   //     price.name = 'Web sem Câmera';
            //   //   }

            //   //   that.prices.push(price);
            //   // }

            //   //   that.proof = that.proofs[0];

            //   //   // console.log(proofs);
            //   //   console.log(that.proof);
            // }
            // console.log(prices);
          } catch (ex) {
            that.doNotRetrivedDetail(ex);
          }

          loader.dismiss();
        }, (error: any) => {
          // that.loading = false;
          loader.dismiss();
          that.doNotRetrivedDetail(error);
        });
      }
    }, (error: any) => {
      console.log(error);
    });
  }

  private doNotRetrivedDetail(error = null) {
    this.prices = [];

    console.log('Não foi possível obter os detalhes da prova.', error);

    let toast = this.toastCtrl.create({
      message: 'Não foi possível obter os detalhes da prova.',
      duration: 3000,
      position: 'bottom'
    });

    toast.present();
  }

  onBack() {
    // this.newSubscriptionProvider.saveDataAndGoToPage(this.newSubscription, -1);
    this.navCtrl.pop({
      animation: 'ios-transition'
    });
  }

  onNext(proofFormLetter: string, proofFormText: string) {
    this.navCtrl.push(NewSubscriptionStep3Page, {
      proofTypeId: this.proofTypeId,
      proofType: this.proofType,
      proofFormLetter: proofFormLetter,
      proofFormText: proofFormText,
      animation: 'ios-transition'
    });
  }

  selectAccessKind(priceName: string, accessKind: string, camera: boolean) {
    this.newSubscription.priceName = priceName;
    // WEB, 1 - Web with Camera
    // WEB, 0 - Web Without Camera
    // APP, 1 - Application
    this.newSubscription.accessKind = accessKind;
    this.newSubscription.camera = camera;

    console.log(this.newSubscription);

    let message = null;

    // DONE: On mobile HTML tag on message do not work
    if (this.platform.is('cordova')) {
      message = 'A prova é ' + this.newSubscription.proofName + ' a ser realizada através do meio ' + this.newSubscription.priceName + '. Deseja continuar?';
    } else {
      message = 'A prova é <strong>' + this.newSubscription.proofName + '</strong> a ser realizada através do meio <strong>' + this.newSubscription.priceName + '</strong>. Deseja continuar?';
    }

    this.alertProvider.doConfirm(message, () => {
      this.newSubscriptionProvider.saveDataAndGoToPage(this.newSubscription,
        NewSubscriptionStep3Page);
    });
  }

  // doVerify() {
  //   if (this.validatorProvider.isEmpty(this.newRegistration.email)) {
  //     this.alertProvider.doAlert('Forneça seu e-mail.', 'Atenção');
  //   } else if (!this.validatorProvider.isEmail(this.newRegistration.email)) {
  //     this.alertProvider.doAlert('Forneça um e-mail válido.', 'Atenção');
  //   } else if (this.validatorProvider.isEmpty(this.newRegistration.federalCode)) {
  //     this.alertProvider.doAlert('Forneça seu CPF.', 'Atenção');
  //   } else if (!this.validatorProvider.isCpf(this.newRegistration.federalCode)) {
  //     this.alertProvider.doAlert('Forneça um CPF válido.', 'Atenção');
  //   } else {
  //     let that = this;

  //     this.newRegistrationProvider.doVerification(this.newRegistration).subscribe((data: any) => {
  //       console.log('Retorno da verificacao: ', data);

  //       if ((data == null) || (data.length == 0)) {

  //         that.newRegistrationProvider.saveDataAndGoToPage(that.newRegistration,
  //           NewRegistrationStep2Page);

  //       } else {

  //         that.navCtrl.push(NewRegistrationExistsPage, {
  //           emails: data
  //         }, {
  //             animation: 'ios-transition'
  //           });

  //       }

  //     }, (error: any) => {
  //       console.log(error);
  //       that.newRegistrationProvider.saveDataAndGoToPage(that.newRegistration,
  //         NewRegistrationStep2Page);
  //     })
  //   }
  // }

}



// WEBPACK FOOTER //
// ./src/pages/new-subscription-step2/new-subscription-step2.ts